export default function(int, ext) {
  if (int === 'failed' && !ext) {
    return {
      label: 'Review Preparation Failure',
      icon: 'close',
      color: '#fc1e1e',
    }
  } else if ((int === 'created' || int === 'in_progress') && !ext) {
    return {
      label: 'Preparing for Review',
      icon: 'time',
      color: '#fbb241',
    }
  } else if (int === 'completed' && !ext) {
    return {
      label: 'Ready For Review',
      icon: 'check',
      color: '#3bb720',
    }
  } else if (int === 'declined' && !ext) {
    return {
      label: 'Declined',
      icon: 'close',
      color: '#fc1e1e',
    }
  } else if ((int === 'completed' || int === 'approved') && (ext === 'created' || ext === 'in_progress')) {
    return {
      label: 'External Publish In Progress',
      icon: 'time',
      color: '#fbb241',
    }
  } else if ((int === 'completed' || int === 'approved' || int === 'published') && ext === 'completed') {
    return {
      label: 'External Publish Completed',
      icon: 'check',
      color: '#3bb720',
    }
  } else if ((int === 'completed' || int === 'approved') && ext === 'failed') {
    return {
      label: 'External Publish Failure',
      icon: 'close',
      color: '#fc1e1e',
    }
  }
}
